// extracted by mini-css-extract-plugin
module.exports = {"roundIcon":"styles_roundIcon__OhpOl","background":"styles_background__uleAV","label":"styles_label__nVNIr","green":"styles_green__1jOBS","primary":"styles_primary__JFQ7w"};